<template>
  <div class="cb-device-test-success">
    <div class="cb-device-test-success__container">
      <img alt="Success Checkmark" src="../assets/icons/checkmark.svg" />
      <h1
        class="cb-device-test-success__heading cb-heading-2"
        tabindex="-1"
        ref="title"
        role="alert"
      >
        Success!
      </h1>
      <p class="cb-device-test-success__body">
        Your CellBridge device is connected and functioning normally!
      </p>
    </div>
    <div class="cb-device-test-success__footer">
      <div class="cb-device-test-success__divider"></div>
      <button
        @click="handleEndTest"
        class="cb-button cb-button--outline-white"
        v-if="manualTestRequired && hasMyADTCredentials"
      >
        End Test
      </button>
      <button
        @click="handleComplete"
        class="cb-button cb-button--outline-white"
        v-else-if="!hasMyADTCredentials"
      >
        Complete Registration
      </button>
      <button
        @click="handleContinue"
        class="cb-button cb-button--outline-white"
        v-else
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState({
      manualTestRequired: (state) => state.userInfo.manualTestRequired,
      hasMyADTCredentials: (state) => state.userInfo.hasMyADTCredentials,
    }),
  },
  mounted() {
    this.$refs.title.focus();
    document.title = 'Cellbridge - Success!';
    this.takeDeviceOffTest();
  },
  methods: {
    handleEndTest() {
      this.$router.push('/mobile-app');
      gtag('event', 'endTestClick', {
        event_label: 'end test',
        event_category: 'deviceSuccess',
        value: 1,
      });
    },
    handleComplete() {
      this.$router.push('/register');
      gtag('event', 'completeClick', {
        event_label: 'register',
        event_category: 'deviceSuccess',
        value: 1,
      });
    },
    handleContinue() {
      this.$router.push('/mobile-app');
      gtag('event', 'continueClick', {
        event_label: 'continue',
        event_category: 'deviceSuccess',
        value: 1,
      });
    },
    ...mapActions(['takeDeviceOffTest']),
  },
};
</script>

<style lang="scss" scoped>
.cb-device-test-success {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 120px 20px 20px;
  box-sizing: border-box;

  &__container {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 40px;
  }

  &__heading {
    margin: 12px 0;
    text-align: center;
  }

  &__body {
    font-size: 18px;
    line-height: 27px;
    text-align: center;
  }

  &__footer {
    width: 100%;

    .cb-button {
      width: 100%;
    }
  }

  @include desktop {
    height: 100%;
    max-width: none;
    padding: 20px;

    &__container {
      flex-grow: 1;
      justify-content: center;
      margin-bottom: 0;
    }

    &__body {
      width: 366px;
    }

    &__footer {
      display: flex;
      flex-direction: column;
    }

    &__divider {
      height: 1px;
      width: 100%;
      background-color: white;
    }

    .cb-button {
      margin-top: 20px;
      width: auto;
      align-self: flex-end;
    }
  }
}
</style>
